import { render } from "./ToDoItem.vue?vue&type=template&id=a709e1b4&ts=true"
import script from "./ToDoItem.vue?vue&type=script&lang=ts"
export * from "./ToDoItem.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__